import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout/Layout";
import LoanServices from "../../services/LoanServices";
import { HollowDotsSpinner } from "react-epic-spinners";
import LoanDetailComponents from "./loanDetailsComponents/LoanDetails";
import Reports from "./loanDetailsComponents/Reports";
import EligigilityDetails from "./loanDetailsComponents/EligigbilityDetails";
import Obligations from "./loanDetailsComponents/Obligations";
import DeclinedTransaction from "./loanDetailsComponents/DeclinedTransaction";
import Obligor from "./loanDetailsComponents/Obligor";
import TurnOver from "./loanDetailsComponents/TurnOver";
import CustomerServices from "../../services/CustomerServices";
import fire from "../../utils/Toastr";

const LoanDetails = () => {
  const report = {
    id: "",
    loanApplicationId: "",
    bureauName: "",
    reportUrl: "",
    debitAccountNumber: "",
    feeAmount: 0,
    isClean: true,
    blockStatus: "",
    dateBlocked: "",
    dateUnBlocked: "",
    bureauHierarchy: 0,
    debitAttempted: true,
    dateDebited: "",
    debitReference: "",
    transferReference: "",
    transferStatus: "",
    blockReference: "",
    unBlockReference: "",
    tenantId: "",
    createdBy: "",
    dateCreated: "",
    modifiedBy: "",
    dateModified: "",
    isDeleted: true,
    deletedBy: "",
    dateDeleted: "",
    extensionData: "",
  };
  const obligation = {
    naration: "",
    amount: 0,
  };
  const declineTransactions = {
    transactionDate: "",
    valueDate: "",
    narration: "",
    credit: 0,
    debit: 0,
    balance: 0,
  };
  const turnOver = {
    scenarioId: "",
    month: 0,
    monthName: "",
    netMonthlyInflow: 0,
    totalMonthlyInflow: 0,
    totalMonthlyOutflow: 0,
    averageMonthlyIncome: 0,
    accountBalanceBroughtForward: 0,
    outFlowPlusBBF: 0,
  };
  const loanId = new URLSearchParams(window.location.search).get("id");

  const [loanDetails, setLoan] = useState({});
  const [reports, setReport] = useState([report]);
  const [eligibility, setEligibility] = useState({});
  const [cashbackedLoanInvestmentDetails, setcashbackedLoanInvestmentDetails] =
    useState({});
  const [obligations, setObligation] = useState([obligation]);
  const [decline, setDeclined] = useState([declineTransactions]);
  const [obligor, setObligor] = useState({});
  const [statementBreakDowns, setStatementBreakDowns] = useState([]);
  const [turnOverScenario, setTurnOverScenario] = useState({
    transactionId: "",
    minNetInflow: 0,
    totalInflow: 0,
    totalOutflow: 0,
    minAverageMonthlyCredit: 0,
    averageTurnoverIsZero: true,
    outFlowThirtyPercentIncomePlusBBF: true,
    netIncomeFlowIsZero: true,
    outFlowIsZero: true,
    averageZeroTurnoverMonth: "",
  });
  const [monthlyTurnOver, setMonthlyTurnOver] = useState([turnOver]);
  const [loading, setLoader] = useState(false);
  const [rejectLoader, setRejectLoader] = useState(false);
  const [approval, setApproval] = useState();

  const [bvnDetails, setBvnDetails] = useState({});

  const [adminType, setAdminType] = useState("")

  const Details = async () => {
    try {
      setLoader(true);
      let response = await LoanServices.loanDetails(loanId);
      setLoan(response.data?.loanDetailsResponse);
      setEligibility(response.data?.eligibilityDetails);
      setcashbackedLoanInvestmentDetails(
        response.data?.loanDetailsResponse.cashbackedLoanInvestmentDetails
      );

      const customer = await CustomerServices.viewCustomer(
        response.data?.loanDetailsResponse?.username
      );
      if (customer) {
        const bvndetails = customer.data.bvnNavigation;
        setBvnDetails(bvndetails);
        setLoader(false);
      }
      setLoader(false);
    } catch (e) {

      setLoader(false);
    }
  };

  const ApproveReject = async (status) => {
    if (status?.toLowerCase() === "approve") {
      setLoader(true);
    }
    setRejectLoader(false);
    const payload = {
      loanApplicationId: loanId,
      actionStatus: status,
    };
    let response = await LoanServices.ApproveRejectLoan(payload);
    if (response) {
      fire("success", response.message);
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    }
    if (status?.toLowerCase() === "approve") {
      setLoader(true);
    }
    setRejectLoader(false);
  };
  const getDetails = async () => {
    var details = sessionStorage.getItem("user");
    var userDetails = JSON.parse(details ?? "");
    var modules = [];
    modules = (userDetails.moduleAssigned || "").split(",");
    var checker = modules.find((x) => x === "loan_approval");
    setApproval(checker);
  };
  useEffect(() => {
    Details();
    getDetails();

    const userDetail = sessionStorage.getItem("user");
    const userDetails = JSON.parse(userDetail);
    setAdminType(userDetails?.roleName);


  }, [loanId]);

  useEffect(() => {
    setReport(loanDetails.creditReportLogs);
    if (eligibility !== null) {
      setObligation(eligibility.obligations);
      setDeclined(eligibility.declineTransactions);
      setObligor(eligibility.obligorRiskRating);
      setTurnOverScenario(eligibility.turnOverScenario);
      setMonthlyTurnOver(eligibility.turnOverScenario?.monthlyCreditTurnovers);
      setStatementBreakDowns(eligibility?.statementBreakDowns);
    }
  }, [loanId, Details]);



  return (
    <>
      <Layout
        title={"Loan Application Details"}
        current={"/loan/view"}
        pageTag="loan"
      >
        <div>
          {loading ? (
            <p>Loading...</p>
          ) : (
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
              <div className="flex flex-col text-center justify-center">
                <p className="py-4 uppercase font-bold">
                  {loanDetails.customerFirstName} {loanDetails.customerLastName}
                </p>
             
                <span className="uppercase">Bvn: {bvnDetails.bvn}</span>
              </div>
              <LoanDetailComponents
                loanDetails={loanDetails}
                cashbackedLoanInvestmentDetails={
                  cashbackedLoanInvestmentDetails
                }
              />
             
              {  reports != null && reports?.length != 0 && (
                <Reports reports={reports} />
              )}
          
              {   eligibility && eligibility !== null && (
                <div className="">
                  <div className="my-12">
                    <EligigilityDetails
                      eligibility={eligibility}
                      loanDetails={loanDetails}
                    />
                  </div>
                  
                    
                  { obligations?.length != 0 && (
                      <div className="">
                        <Obligations obligations={obligations} />
                      </div>
                    )}


                  { loanDetails.loanType?.toLowerCase() != "cashbacked" && (
                    <div className="my-12">
                      <DeclinedTransaction decline={decline} />
                    </div>
                  )}
                  
                  {loanDetails.loanType?.toLowerCase() != "cashbacked" && (
                    <div className="my-12">
                      <Obligor obligor={obligor} />
                    </div>
                  )}
                 
                  {  loanDetails.loanType?.toLowerCase() != "cashbacked" && (
                    <div className="my-12">
                      <TurnOver salary={statementBreakDowns} />
                    </div>
                  )}
                </div>
              )}
           
              {    loanDetails.loanApplicationProgressState ===
            "PendingDisbursement" && approval === "loan_approval" && (adminType.toLowerCase() === "risk management" || adminType.toLowerCase().includes("risk")) &&
                <>
                  <div className="my-10 float-right">
                    <div className="">
                      {loading === false ? (
                        <button
                          type="button"
                          onClick={() => ApproveReject("Approve")}
                          className="rounded-md btn-primary  btn py-2 font-semibold text-white mr-5 shadow-sm w-[200px]"
                        >
                          Approve Loan
                        </button>
                      ) : (
                        <HollowDotsSpinner size={20} color="#079D4F" />
                      )}
                      {rejectLoader === false ? (
                        <button
                          type="button"
                          onClick={() => ApproveReject("Reject")}
                          className="rounded-md btn-error btn py-2 font-semibold text-black shadow-sm  w-[200px]"
                        >
                          Reject Loan
                        </button>
                      ) : (
                        <HollowDotsSpinner size={20} color="#079D4F" />
                      )}
                    </div>
                  </div>
                </>
              }
            </div>
          )}
        </div>
      </Layout>
    </>
  );
};

export default LoanDetails;
